import axios from './axios';

export const loadMetricsMachines = machineId =>
  axios({
    method: 'get',
    url: `/v1/machines/${machineId}/production-metrics`
  });
